/**
 * گزینه‌های پیش‌فرض (نخ، دهانه، عرض، رنگرزی، رنگ، گیرنده) — افزودن، تغییرِ نام/کد، ترتیب، پنهان، حذف.
 * کاربر: «یک بخشی داشته باشد که موارد پیش‌فرض را عوض کنیم و کم و زیاد کنیم». مقدارِ تازه‌ای که در فرم‌ها تایپ شود
 * خودکار به همین فهرست اضافه می‌شود.
 */
import React, { useState } from "react";
import { Button, Input, Popconfirm, Segmented, Space, Switch, message } from "antd";
import { ArrowDownOutlined, ArrowUpOutlined, DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import api from "../../api/client";
import { apiError } from "../../utils/apiError";
import { BASE, fa, toEn } from "./dyeShared";

export default function DyeSettings({ kinds, options, onChanged, canEdit }) {
  const [kind, setKind] = useState("yarn");
  const [val, setVal] = useState("");
  const [code, setCode] = useState("");
  const list = options[kind] || [];
  const run = async (fn, ok) => {
    try { await fn(); if (ok) message.success(ok); await onChanged(); } catch (e) { message.error(apiError(e)); }
  };
  const add = () => {
    if (!val.trim()) return;
    run(() => api.post(`${BASE}/options`, { kind, value: val, code: kind === "color" ? code || null : null }), "اضافه شد")
      .then(() => { setVal(""); setCode(""); });
  };
  const move = (i, d) => {
    const ids = list.map((o) => o.id);
    const j = i + d;
    if (j < 0 || j >= ids.length) return;
    [ids[i], ids[j]] = [ids[j], ids[i]];
    run(() => api.post(`${BASE}/options/reorder`, { kind, ids }));
  };
  const patch = (o, body) => run(() => api.patch(`${BASE}/options/${o.id}`, body));

  return (
    <div>
      <div className="dye-scroll-x">
        <Segmented value={kind} onChange={setKind} options={Object.entries(kinds).map(([value, label]) => ({ value, label }))} />
      </div>
      <div className="dye-mute" style={{ margin: "8px 0" }}>
        ترتیبِ این فهرست همان ترتیبِ دکمه‌های سریعِ فرم است. هر مقدارِ تازه‌ای که در فرم تایپ کنید خودکار اینجا اضافه می‌شود.
      </div>
      {canEdit && (
        <Space.Compact block style={{ marginBottom: 10 }}>
          <Input size="large" placeholder={`${kinds[kind]} تازه`} value={val} onChange={(e) => setVal(e.target.value)} onPressEnter={add} />
          {kind === "color" && <Input size="large" placeholder="کد رنگ" value={code} onChange={(e) => setCode(e.target.value)}
            style={{ maxWidth: 110 }} onPressEnter={add} />}
          <Button size="large" type="primary" icon={<PlusOutlined />} onClick={add} />
        </Space.Compact>
      )}
      {list.length === 0 && <div className="dye-mute">فهرست خالی است.</div>}
      {list.map((o, i) => (
        <div className={"dye-opt-row" + (o.active ? "" : " dye-off")} key={o.id}>
          <Input variant="borderless" defaultValue={fa(o.value)} disabled={!canEdit}
            onBlur={(e) => { const v = toEn(e.target.value).trim(); if (v && v !== o.value) patch(o, { value: v }); }} />
          {kind === "color" && <Input variant="borderless" placeholder="کد" defaultValue={fa(o.code)} disabled={!canEdit}
            style={{ maxWidth: 90 }} onBlur={(e) => { const v = toEn(e.target.value).trim(); if (v !== (o.code || "")) patch(o, { code: v || null }); }} />}
          <span className="dye-mute" title="دفعاتِ استفاده">{o.use_count ? `×${fa(o.use_count)}` : ""}</span>
          {canEdit && (
            <>
              <Switch size="small" checked={o.active} onChange={(v) => patch(o, { active: v })} />
              <Button type="text" size="small" icon={<ArrowUpOutlined />} disabled={i === 0} onClick={() => move(i, -1)} />
              <Button type="text" size="small" icon={<ArrowDownOutlined />} disabled={i === list.length - 1} onClick={() => move(i, 1)} />
              <Popconfirm title="از فهرست حذف شود؟ (پارت‌های ثبت‌شده عوض نمی‌شوند)"
                onConfirm={() => run(() => api.delete(`${BASE}/options/${o.id}`), "حذف شد")}>
                <Button type="text" size="small" danger icon={<DeleteOutlined />} />
              </Popconfirm>
            </>
          )}
        </div>
      ))}
    </div>
  );
}
